<template>
  <div id="popup-container" class="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Additional Content
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="assetbar">
      <v-row>
        <v-col md="12">
          <v-text-field
            :error-messages="messages.title"
            v-model="asset.title"
            label="Title"
            type="text"
            filled
          ></v-text-field>
          <drop-zone
            :type="type"
            class="mt-5"
            :accepted="accepted"
            :text="dropZoneText"
            :maxFilesize="maxUploadSize"
          ></drop-zone>
            <label v-if="messages.file"
            :error-messages="messages.file"
            class="v-messages theme--light error--text">{{ messages.file[0] }}
            </label>
              <p class="block text-left mt-4 caption">
              Max upload filesize: {{maxUploadSize}}MB <br />
              Accepted file formats: pdf, doc, docx, xls, xlsx, ppt, pptx, png, jpg, mp4
            </p>
        </v-col>
      </v-row>
      <v-row class="assets-list" v-if="materials.length > 0">
        <v-col md="12">
          <v-list v-for="(item, index) in materials" :key="index" dense>
            <v-list-item :key="index">
              <template>
                <v-list-item-icon>
                  <v-icon>{{ icon(item.file.data.mime_type) }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="ml-5 text-left">
                  <v-list-item-title>{{
                    item.file.data.original_name
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.title }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon
                    color="$improve-grey-900"
                    @click.prevent="remmoveAsset(item.id, index)"
                    >fa fa-trash</v-icon
                  >
                </v-list-item-icon>
              </template>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button"  @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" loading></v-btn>
        <v-btn v-else color="dark-blue" class="add-course-button ml-1" @click.once="addChannelAsset"
          >Save</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import channelAPI from "@/api/channel.js";
import DropZone from "@/components/global/Dropzone";

export default {
  name: "SupplementalMaterial",
  components: {
    DropZone
  },
  props: {
    params: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      type: "channel-asset",
      asset: {},
      accepted:
        "image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,video/mp4",
      dropZoneText: "Click here to upload Image or Video or Document",
      dropZoneTypes: "",
      channel: {},
      materials: [],
      selectedIcon: null,
      messages: {},
      loading: false,
      assetRemovedSuccessMessage: "Additional content has been removed",
      assetRemovedErrorMessage:
        "Oops, something went wrong! Additional content has not been removed",
      successMessage: "Additional content successfully added.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      maxUploadSize: 150
    };
  },
  mounted() {
    //this.setEventBus();
    this.getChannel();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    remmoveAsset(id, index) {
      channelAPI
        .removeChannelAsset(id)
        .then(() => {
          this.$snotify.success(this.assetRemovedSuccessMessage);
          this.materials.splice(index, 1);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.$snotify.error(this.assetRemovedErrorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getChannel() {
      channelAPI
        .getChannel(this.id, "?include=supplementalMaterial")
        .then(resp => {
          this.materials = resp.data.data.supplementalMaterial.data;
        });
    },
    addChannelAsset() {
      this.loading = true;
      channelAPI
        .addChannelAsset(
          this.id,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails,
          this.asset
        )
        .then(() => {
          this.closePanel();
          //EventBus.$emit("COURSES_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    icon(mimeType) {
      var icon = '';
      switch (mimeType) {
        case 'video/mp4':
          icon = 'fa fa-video';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          icon = 'fa-file-word';
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          icon = 'fa-file-ppt';
          break;
        case 'application/pdf':
          icon = 'fa-file-pdf';
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          icon = 'fa-file-spreadsheet';
          break;
        case 'image/jpeg':
          icon = 'fa-image';
          break;  
        case 'image/png':
          icon = 'fa-image';
          break;        
        default:
          icon = 'fa-file';
          break;
      }
      return icon;
    },
  }
};
</script>
<style>
.assets-list {
}
.assetbar {
  height: calc(100% - 150px);
  overflow-y: scroll;
}
.popup-container {
  height: 100%;
}
</style>
